import { render, staticRenderFns } from "./HomeDrawer.vue?vue&type=template&id=5b89a1d0&scoped=true&"
import script from "./HomeDrawer.vue?vue&type=script&lang=js&"
export * from "./HomeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./HomeDrawer.vue?vue&type=style&index=0&id=5b89a1d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89a1d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAvatar,VCard,VCardTitle,VIcon,VNavigationDrawer})
